import {
  GroupVisitControllerApi,
  UpdateGroupVisitGroupStatusGroupStatusEnum,
} from "@/services";
import {
  getConfigObject,
  getXtenantId,
  useMutationWithLoading,
} from "@/utils/utils";

type Params = {
  groupVisitId: string;
  groupStatus: UpdateGroupVisitGroupStatusGroupStatusEnum;
};

/**
 * @author Atish Bagate
 */
export const useUpdateGroupVisitStatus = () =>
  useMutationWithLoading(async ({ groupVisitId, groupStatus }: Params) =>
    new GroupVisitControllerApi(getConfigObject()).updateGroupVisitGroupStatus(
      groupVisitId,
      groupStatus,
      getXtenantId()
    )
  );
